import {AlertIcon} from '@chakra-ui/react';

export default function ChakraAlertIcon({...rest}) {
    return <AlertIcon {...rest} />;
}
